// Componentes
import Vacina from '../components/organisms/HistoryVaccination'

function HistoryVaccination() {
  return <Vacina />
}

export default HistoryVaccination
